/**
 * Calendar-date validation shared by every screen that takes a date from the address bar.
 *
 * Moved here from `src/app/routes/overview/scope.ts` when the exit consolidation screen needed
 * the same check: a feature may not import from `src/app/` (G11 dependency direction), and a
 * second copy of the rule would be two definitions of what a valid date is.
 */

/**
 * An ISO calendar date, and nothing else.
 *
 * A pasted URL is untrusted input: `?asOf=yesterday` would otherwise reach the API as a query
 * parameter and come back as a 422 a planner cannot act on. Validated here so the screen can
 * render its own designed refusal instead, in the planner's language.
 */
export function isCalendarDate(value: string): boolean {
  if (!/^\d{4}-\d{2}-\d{2}$/.test(value)) return false;
  const parsed = new Date(`${value}T00:00:00Z`);
  return !Number.isNaN(parsed.getTime()) && parsed.toISOString().startsWith(value);
}
